module.exports = __webpack_public_path__ + "static/media/cq_freccia_destra_blu.e4c11ba3.svg";